import { get } from '@alltrails/core/utils/get';
import { post } from '@alltrails/core/utils/post';
import type GarminPermissionsResponse from '@alltrails/types/GarminPermissionsResponse';

export const activityExport = 'ACTIVITY_EXPORT';
export const courseImport = 'COURSE_IMPORT';
export type GarminPermissionTypes = typeof activityExport | typeof courseImport;

const getGarminPermissions = () => get<GarminPermissionsResponse>('/api/alltrails/garmin/users');

const postGarminCourse = (mapId: number) => post<void>('/api/alltrails/garmin/courses', { at_map_id: mapId });

export { getGarminPermissions, postGarminCourse };
